import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logOut } from './auth/slice';

const getToken = () => localStorage.getItem('token');
const getRole = () => localStorage.getItem('role');

const getBaseUrl = (api?: string) => {
  const role = getRole();
  if (api) {
    return `${process.env.REACT_APP_API_URL}/api/${api}`;
  }
  return role !== 'director'
    ? `${process.env.REACT_APP_API_URL}/api/worksupport`
    : `${process.env.REACT_APP_API_URL}/api`;
};

const getAuthorizationHeader = () => {
  const token = getToken();
  return token ? `Bearer ${token}` : '';
};

let isLoggingOut = false;

export const baseQueryWithReauth = (apiName?: string) => {
  return async (args: any, apiObj: any, extraOptions: any) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: getBaseUrl(apiName),
      prepareHeaders: (headers) => {
        headers.set('Accept', 'application/json');

        const token = getToken();
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }

        return headers;
      },
    });

    if (args.body instanceof FormData) {
      const modifiedArgs = {
        ...args,
        headers: {
          ...args.headers,
          Accept: 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      };
      if (modifiedArgs.headers['Content-Type']) {
        delete modifiedArgs.headers['Content-Type'];
      }
      const result = await baseQuery(modifiedArgs, apiObj, extraOptions);

      if (result.error && result.error.status === 401) {
        const currentPath = window.location.pathname;
        const isOnLoginPage = currentPath === '/login' || currentPath === '/';

        if (!isLoggingOut) {
          isLoggingOut = true;
          apiObj.dispatch(logOut());
          localStorage.removeItem('token');
          localStorage.removeItem('chatToken');
          localStorage.removeItem('role');

          const baseUrl = process.env.REACT_APP_BASE_URL || '';
          const loginPath = baseUrl === '/' ? 'login' : `${baseUrl}/login`;
          if (!isOnLoginPage) {
            window.location.href = loginPath;
          }
        }
      }

      return result;
    } else {
      const modifiedArgs = {
        ...args,
        headers: {
          'Content-Type': 'application/json',
          ...args.headers,
          Accept: 'application/json',
          Authorization: getAuthorizationHeader(),
        },
      };

      const result = await baseQuery(modifiedArgs, apiObj, extraOptions);

      if (result.error && result.error.status === 401) {
        const currentPath = window.location.pathname;
        const isOnLoginPage = currentPath === '/login' || currentPath === '/';

        if (!isLoggingOut) {
          isLoggingOut = true;
          apiObj.dispatch(logOut());
          localStorage.removeItem('token');
          localStorage.removeItem('chatToken');
          localStorage.removeItem('role');

          const baseUrl = process.env.REACT_APP_BASE_URL || '';
          const loginPath = baseUrl === '/' ? 'login' : `${baseUrl}/login`;
          if (!isOnLoginPage) {
            window.location.href = loginPath;
          }
        }
      }

      return result;
    }
  };
};
